import React, {useEffect, useRef, useState} from "react";
import * as yup from "yup";
import "yup-phone";
import "../../Tenant.css";
import "../../../../../node_modules/draft-js/dist/Draft.css";
import {DeleteOutline,} from "@mui/icons-material";
import {TextField} from "@material-ui/core";
import Button from "@mui/material/Button";
import {DataGrid} from "@mui/x-data-grid";
import {makeStyles} from "@material-ui/core/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Tooltip from "@mui/material/Tooltip";
import {
    useMediaQuery,
    Alert,
    Grid,
    FormControlLabel,
    Switch as MuiSwitch,
    Divider,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import {ApiDetails, KEY} from "../../../../Constants";
import NonEditableRichTextEditor from "../../../../components/RichTextEditorNotEditable/NonEditableRichTextEditor";
import {convertFromRaw, convertToRaw, EditorState} from "draft-js";
import draftToHtml from "draftjs-to-html";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import RichTextEditor from "../../../../components/RichTextEditorEditable/RichTextEditor";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import {showSnackbar} from "../../../../components/SnackBar/SnackBar";
import CryptoJS from "crypto-js";
import {useNavigate} from 'react-router-dom';
import {styled} from "@mui/system";
import { handle401Unauthorized, handle403Forbidden } from '../../../../utils/authErrorHandler';
import { getAuthToken } from '../../../../services/api/client';
import leaseManagementApi from '../../../../services/api/leaseManagement';
import { LogOut, X as CloseIcon, Info, AlertCircle, CheckCircle } from 'lucide-react';



const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    "& .MuiDataGrid-columnHeaders": {
        fontSize: "0.9rem",
        fontWeight: 600,
        backgroundColor: "#FBF4F0", // Logo blue
        color: "black", // White text
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: "#F4F6F8", // Subtle hover color
    },
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
    "& .MuiDataGrid-cell": {
        fontSize: "0.8rem",
        color: "#002961", // Top bar color
    },
}));
const useStyles = makeStyles({
    root: {
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeaders": {
            fontSize: 16,
            color: "darkblue",
            backgroundColor: "rgb(245,245,245)",
        },
    },
});
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const themeColor = "#2C5283";

const StyledTerminateDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
        minWidth: '500px',
        maxWidth: '700px',
        [theme.breakpoints.down('sm')]: {
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxWidth: 'none',
            minWidth: 'unset'
        }
    },
}));

const DialogTitleStyled = styled(DialogTitle)({
    color: themeColor,
    fontWeight: 600,
    fontSize: '1.3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#f8f9fa',
    padding: '20px 24px',
});

const TerminateButton = styled(Button)({
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    padding: '8px 20px',
    backgroundColor: '#d32f2f',
    color: 'white',
    '&:hover': {
        backgroundColor: '#b71c1c',
    },
    '&:disabled': {
        backgroundColor: '#e0e0e0',
        color: '#9e9e9e',
    },
});

export default function Notices(props) {
    const navigate = useNavigate();

    const matches = useMediaQuery("(max-width:700px)");
    const [dataSet, setDataSet] = useState(false);

    const [tenantLoading, setTenantLoading] = React.useState(false);

    const [editorState, setEditorState] = React.useState(() =>
        EditorState.createEmpty()
    );

    const [tenant, setTenant] = useState({first_name: "", last_name: "", state: "", notice: ""});

    const initialValues3 = {
        first_name: tenant?.first_name || "",
        last_name: tenant?.last_name || "",
        phone_number: tenant?.phone_number || "",
        national_id: tenant?.national_id || "",
        unit: tenant?.house_number || "",
        property_name: tenant?.property_name || "",
        landlord_id: tenant?.landlord_id || "",
        tenant_id: tenant?.tenant_id || "",
    };

    // Safe decryption function
    const safeDecrypt = (key) => {
        try {
            return CryptoJS.AES.decrypt(localStorage.getItem(key), KEY).toString(CryptoJS.enc.Utf8) || "";
        } catch {
            return "";
        }
    };

    const originalText = safeDecrypt("myMap");

    const [notices, setNotices] = useState([]);

    const getNotices = () => {
        fetch(
            ApiDetails +
            "pegasus/visionary/authorization/admin/get/specific/tenant/notices",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": getAuthToken() || ""  // Replace with your actual token variable
                },
                body: JSON.stringify({
                    tenant_id: props.tenantID,
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                console.log("NOTICES");
                console.log(data);
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    //Fetch tenant notices
                    setNotices(data);

                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Kindly try again later.",
                        type: "error", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });
                }
            })
            .catch((error) => console.error("Error fetching image:", error));
    };

    useEffect(() => {
        getNotices();
        setDataSet(true);

    }, [])

    useEffect(() => {
        // Fetch the tenant data
        fetch(ApiDetails + "pegasus/visionary/tenant/get/specific/tenant", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""  // Replace with your actual token variable
            },
            body: JSON.stringify({tenant_id: props.tenantID, property_id: props.propertyID}),
        })
            .then((response) => response.json())
            .then((data) => {
                setTenant(data);
            })
            .catch((err) => console.error(err));

    }, []);

    const deleteNotice = (id) => {
        fetch(
            ApiDetails +
            "pegasus/visionary/authorization/admin/delete/specific/tenant/notices",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": getAuthToken() || ""
                },
                body: JSON.stringify({
                    id: id,
                    tenant_id: props.tenantID,
                    recall_reason: ""
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    // console.log(data)
                    window.location.reload();
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Kindly try again later.",
                        type: "error", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });
                }
            })
            .catch((error) => console.error("Error fetching image:", error));
    };


    const [dateToday] = useState(new Date());
    const [dateToVacate, setDateToVacate] = useState(new Date());

    function toMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);

        return date.toLocaleString("en-US", {
            month: "long",
        });
    }

    const handleClose = () => {
        setVacatingModal(false);
        setForceVacatingModal(false);
    };


    const sendVacatingNotice = (values) => {
        console.log("sendVacatingNotice called");
        console.log("Current tenant data:", tenant);
        console.log("Current dateToVacate:", dateToVacate);
        console.log("Current editorState:", editorState);

        setTenantLoading(true);
        const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        values = {
            first_name: tenant?.first_name || "",
            last_name: tenant?.last_name || "",
            phone_number: tenant?.phone_number || "",
            national_id: tenant?.national_id || "",
            unit: tenant?.house_number || "",
            property_name: tenant?.property_name || "",
            landlord_id: tenant?.landlord_id || "",
            tenant_id: tenant?.tenant_id || "",
            date_to_vacate_house:
                toMonthName(new Date(dateToVacate.toJSON()).getMonth()) +
                " " +
                new Date(dateToVacate.toJSON()).getDate() +
                ", " +
                new Date(dateToVacate.toJSON()).getFullYear(),
            date_notice_given: new Date(),
            reasons_for_vacating: JSON.stringify(
                convertToRaw(editorState.getCurrentContent())
            ),
            landlord_notice: true,
        };

        console.log("Sending vacating notice with data:", values);

        // "proxy":"http://0.0.0.0:8080/pegasus/visionary",
        fetch(ApiDetails + "pegasus/visionary/tenant/app/AddNotice", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""  // Replace with your actual token variable
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    await getNotices();
                    showSnackbar({
                        title: "Success!",
                        message: "Notice uploaded successfully.",
                        type: "success", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });
                    setTenantLoading(false);
                    handleClose();
                    if (new Date(dateToVacate.toJSON()).getFullYear() === new Date().getFullYear() &&
                        new Date(dateToVacate.toJSON()).getMonth() === new Date().getMonth() &&
                        new Date(dateToVacate.toJSON()).getDate() === new Date().getDate()) {

                        navigate(-1);
                    }
                } else {
                    setTenantLoading(false);
                    handleClose();
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Kindly try again later.",
                        type: "error", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });
                }
            })
            .catch((err) => {
                setTenantLoading(false);
                handleClose();

                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error", // success | error | warning | info
                    position: {vertical: "bottom", horizontal: "right"}, // Custom position
                });
            });


    };


    let dateSchema = yup.object().shape({
        phone_number: yup.string().phone("KE", true).required("Required"),
    });

    const classes = useStyles();

    const [vacatingModal, setVacatingModal] = useState(false);
    const [forceVacatingModal, setForceVacatingModal] = useState(false);

    // Terminate Lease State
    const [showTerminateDialog, setShowTerminateDialog] = useState(false);
    const [terminateLoading, setTerminateLoading] = useState(false);
    const [leaseDetails, setLeaseDetails] = useState(null);
    const [terminateForm, setTerminateForm] = useState({
        terminationReason: '',
        vacateDate: new Date().toISOString().split('T')[0],
        refundDeposit: false
    });

    // Check if lease is active
    const isLeaseActive = props.tenantData?.lease_status === 'ACTIVE' || props.tenantData?.state === 'ACTIVE';

    // Load lease details when dialog opens
    const loadLeaseDetails = async () => {
        if (!props.tenantData?.lease_id || !props.landlordId) return;

        try {
            const response = await leaseManagementApi.getLeaseDetails({
                lease_id: props.tenantData.lease_id,
                landlord_id: props.landlordId
            });

            if (response.ok) {
                setLeaseDetails(response.data);
            }
        } catch (error) {
            console.error('Error loading lease details:', error);
        }
    };

    const handleOpenTerminateDialog = () => {
        setTerminateForm({
            terminationReason: '',
            vacateDate: new Date().toISOString().split('T')[0],
            refundDeposit: false
        });
        loadLeaseDetails();
        setShowTerminateDialog(true);
    };

    const handleCloseTerminateDialog = () => {
        setShowTerminateDialog(false);
        setTerminateForm({
            terminationReason: '',
            vacateDate: '',
            refundDeposit: false
        });
    };

    const handleTerminateLease = async () => {
        if (!terminateForm.terminationReason || !terminateForm.vacateDate) {
            showSnackbar({
                title: "Validation Error!",
                message: "Please fill in all required fields.",
                type: "error",
                position: { vertical: "bottom", horizontal: "right" },
            });
            return;
        }

        if (!window.confirm('Are you sure you want to terminate this lease? This action cannot be undone.')) {
            return;
        }

        try {
            setTerminateLoading(true);
            const response = await leaseManagementApi.terminateLease({
                lease_id: props.tenantData?.lease_id,
                landlord_id: props.landlordId,
                termination_reason: terminateForm.terminationReason,
                vacate_date: new Date(terminateForm.vacateDate).toISOString(),
                refund_deposit: terminateForm.refundDeposit
            });

            if (response.ok) {
                showSnackbar({
                    title: "Success!",
                    message: response.data.message || "Lease terminated successfully!",
                    type: "success",
                    position: { vertical: "bottom", horizontal: "right" },
                });

                // Show deposit refund details
                if (terminateForm.refundDeposit && response.data.refund_status) {
                    const refundMessage = `
Deposit Refund Details:
• Deposit Held: KES ${response.data.deposit_held?.toLocaleString()}
• Outstanding Balance: KES ${response.data.outstanding_balance?.toLocaleString()}
• Amount Refunded: KES ${response.data.deposit_refunded?.toLocaleString()}
• Status: ${response.data.refund_status}
                    `.trim();

                    setTimeout(() => {
                        alert(refundMessage);
                    }, 500);
                }

                handleCloseTerminateDialog();
                props.onLeaseUpdated?.();
            } else {
                showSnackbar({
                    title: "Error!",
                    message: response.data?.Error || "Failed to terminate lease.",
                    type: "error",
                    position: { vertical: "bottom", horizontal: "right" },
                });
            }
        } catch (error) {
            console.error('Error terminating lease:', error);
            showSnackbar({
                title: "Error!",
                message: "Failed to terminate lease. Please try again.",
                type: "error",
                position: { vertical: "bottom", horizontal: "right" },
            });
        } finally {
            setTerminateLoading(false);
        }
    };


    const noticeColumns = [
        {
            field: "date_created",
            align: "center",
            headerAlign: "center",
            headerName: "Notice Given",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
                return params.value ? new Date(params.value).toLocaleDateString() : "N/A";
            }
        },
        {
            field: "date_to_vacate_house",
            headerName: "Date to Vacate",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
        },
        {
            field: "recalled",
            headerName: "Status",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <div style={{
                        padding: "6px 12px",
                        borderRadius: "6px",
                        backgroundColor: params.value ? "#fff3e0" : "#e8f5e9",
                        color: params.value ? "#e65100" : "#2e7d32",
                        fontWeight: "bold",
                        fontSize: "0.85rem"
                    }}>
                        {params.value ? "RECALLED" : "ACTIVE"}
                    </div>
                );
            }
        },
        {
            field: "recall_reason",
            headerName: "Recall Reason",
            headerAlign: "center",
            align: "left",
            minWidth: 180,
            flex: 1.2,
            renderCell: (params) => {
                return params.value && params.value.trim() !== "" ? params.value : "—";
            }
        },
        {
            field: "notice_checks",
            headerName: "Compliance",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 0.8,
            renderCell: (params) => {
                return params.value ? (
                    <div style={{
                        padding: "6px 12px",
                        borderRadius: "6px",
                        backgroundColor: "#e3f2fd",
                        color: "#1565c0",
                        fontWeight: "bold",
                        fontSize: "0.85rem"
                    }}>
                        ✓ Passed
                    </div>
                ) : "—";
            }
        },
        {
            field: "reasons_for_vacating",
            headerName: "Reason",
            headerAlign: "center",
            align: "left",
            minWidth: 180,
            flex: 1.2,
            renderCell: (params) => {
                try {
                    if (params.value) {
                        const parsed = JSON.parse(params.value);
                        if (parsed.blocks && parsed.blocks[0]) {
                            return parsed.blocks[0].text || "—";
                        }
                    }
                    return "—";
                } catch (e) {
                    return "—";
                }
            }
        },
        {
            field: "id",
            headerName: "Actions",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            alignContent: "center",
                            alignItems: "center",
                            gap: "10px"
                        }}
                        className="userListAction"
                    >
                        <Button
                            size="small"
                            onClick={(event) => {
                                setVacatingModal(true);
                            }}
                            variant="outlined"
                        >
                            View
                        </Button>

                        <Tooltip title="Delete" placement="bottom-start">
                            <DeleteOutline
                                className="userListDelete"
                                style={{
                                    color: "red",
                                    cursor: "pointer"
                                }}
                                onClick={async () => {
                                    await deleteNotice(params.row.id);
                                }}
                            />
                        </Tooltip>
                    </div>
                );
            },
        },
    ];


    return (
        <div>
            <Dialog
                open={vacatingModal}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="sm"
                fullWidth
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Vacating Notice Details
                    </div>
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "20px",
                    }}
                >
                    <small
                        style={{
                            color: "red",
                        }}
                    >
                        Kindly refresh if details are not clear
                    </small>
                    <br/>
                    <TextField
                        disabled
                        label="First Name"
                        variant="outlined"
                        value={new Map(Object.entries(tenant)).get("first_name")}
                        InputLabelProps={{shrink: true}}
                        style={{marginTop: "10px", width: "100%"}}
                    />
                    <TextField
                        disabled
                        label="Last Name"
                        variant="outlined"
                        value={new Map(Object.entries(tenant)).get("last_name")}
                        InputLabelProps={{shrink: true}}
                        style={{marginTop: "10px", width: "100%"}}
                    />
                    <TextField
                        disabled
                        label="Date To Vacate"
                        variant="outlined"
                        value={new Map(
                            Object.entries(new Map(Object.entries(tenant)).get("notice"))
                        ).get("date_to_vacate_house")}
                        InputLabelProps={{shrink: true}}
                        style={{marginTop: "10px", width: "100%"}}
                    />
                    <TextField
                        disabled
                        label="Date Notice Given"
                        variant="outlined"
                        value={new Map(
                            Object.entries(new Map(Object.entries(tenant)).get("notice"))
                        ).get("date_created")}
                        InputLabelProps={{shrink: true}}
                        style={{marginTop: "10px", width: "100%"}}
                    />

                    {/* Notice Checks Status */}
                    {new Map(Object.entries(new Map(Object.entries(tenant)).get("notice") || {})).get("notice_checks") && (
                        <div style={{
                            marginTop: "15px",
                            padding: "12px",
                            backgroundColor: "#e8f5e9",
                            border: "1px solid #4caf50",
                            borderRadius: "8px"
                        }}>
                            <div style={{fontWeight: "bold", marginBottom: "8px", color: "#2e7d32"}}>
                                Notice Compliance Checks
                            </div>
                            <div style={{fontSize: "0.9rem"}}>
                                <div style={{marginBottom: "6px"}}>
                                    ✓ Duration Check: Passed
                                </div>
                                <div style={{marginBottom: "6px"}}>
                                    ✓ Minimum Stay Check: Passed
                                </div>
                                <div style={{marginBottom: "6px"}}>
                                    ✓ Landlord Notice: Verified
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Recall Status */}
                    {new Map(Object.entries(new Map(Object.entries(tenant)).get("notice") || {})).get("recalled") && (
                        <div style={{
                            marginTop: "15px",
                            padding: "12px",
                            backgroundColor: "#fff3e0",
                            border: "1px solid #ff9800",
                            borderRadius: "8px"
                        }}>
                            <div style={{fontWeight: "bold", marginBottom: "8px", color: "#e65100"}}>
                                Notice Status: RECALLED
                            </div>
                            {new Map(Object.entries(new Map(Object.entries(tenant)).get("notice") || {})).get("recall_reason") && (
                                <TextField
                                    disabled
                                    label="Recall Reason"
                                    variant="outlined"
                                    multiline
                                    rows={2}
                                    fullWidth
                                    value={new Map(Object.entries(new Map(Object.entries(tenant)).get("notice") || {})).get("recall_reason")}
                                    InputLabelProps={{shrink: true}}
                                    style={{marginTop: "10px"}}
                                />
                            )}
                        </div>
                    )}
                    <br/>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "20px",
                        }}
                    >
                        {dataSet &&
                        new Map(Object.entries(tenant)).get("state") === "NOTICE" ? (
                            <NonEditableRichTextEditor
                                richTextValue={EditorState.createWithContent(
                                    convertFromRaw(
                                        JSON.parse(
                                            new Map(
                                                Object.entries(
                                                    new Map(Object.entries(tenant)).get("notice")
                                                )
                                            ).get("reasons_for_vacating")
                                        )
                                    )
                                )}
                            />
                        ) : (
                            <></>
                        )}
                        {/*<Editor editorState={editorState} onChange={setEditorState}/>*/}
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "end",
                            marginTop: "20px",
                        }}
                    >
                        <Button onClick={() => setVacatingModal(false)}>
                            <span style={{color: "green"}}>Close</span>
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                maxWidth="md"
                open={forceVacatingModal}
                onOpen={() => console.log("Add Notice modal opened")}
                onClose={() => {
                    console.log("Add Notice modal closing");
                    setForceVacatingModal(false);
                }}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        borderRadius: "12px",
                        padding: "20px",
                        backgroundColor: "#f9f9f9",
                    },
                }}
            >
                <DialogTitle>
                    <div
                        style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            color: "#398DD2",
                            letterSpacing: "0.5px",
                            marginBottom: "10px",
                        }}
                    >
                        Vacating Notice
                    </div>
                </DialogTitle>
                <DialogContent style={{padding: "20px"}}>
                    <Formik initialValues={initialValues3} onSubmit={sendVacatingNotice}>
                        {(props) => (
                            <Form noValidate>
                                {/* Date Fields */}
                                <div style={{display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px"}}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Date Today"
                                            disabled
                                            value={dateToday}
                                            inputFormat="MM/DD/YYYY"
                                            renderInput={(params) => (
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    sx={{backgroundColor: "#fff", borderRadius: "8px"}}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Date To Vacate"
                                            inputFormat="MM/DD/YYYY"
                                            value={dateToVacate}
                                            onChange={(newValue) => setDateToVacate(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    sx={{backgroundColor: "#fff", borderRadius: "8px"}}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </div>

                                {/* Rich Text Editor */}
                                <div style={{
                                    marginTop: "20px",
                                    backgroundColor: "#fff",
                                    padding: "10px",
                                    borderRadius: "8px"
                                }}>
                                    <RichTextEditor
                                        richTextValue={editorState}
                                        change={(value) => {
                                            setEditorState(value);
                                        }}
                                    />
                                </div>

                                {/* Action Buttons */}
                                <div style={{display: "flex", justifyContent: "space-between", marginTop: "20px"}}>
                                    <Button
                                        onClick={() => setForceVacatingModal(false)}
                                        sx={{
                                            color: "#fff",
                                            backgroundColor: "#d32f2f",
                                            "&:hover": {backgroundColor: "#b71c1c"},
                                            borderRadius: "8px",
                                            padding: "8px 20px",
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <LoadingButton
                                        type="submit"
                                        size="medium"
                                        loading={tenantLoading}
                                        startIcon={<SendIcon/>}
                                        sx={{
                                            color: "#fff",
                                            backgroundColor: "#388E3C",
                                            "&:hover": {backgroundColor: "#2E7D32"},
                                            borderRadius: "8px",
                                            padding: "8px 20px",
                                        }}
                                    >
                                        Submit
                                    </LoadingButton>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>

            {/* Terminate Lease Dialog */}
            <StyledTerminateDialog open={showTerminateDialog} onClose={handleCloseTerminateDialog}>
                <DialogTitleStyled>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LogOut size={24} />
                        Terminate Lease
                    </Box>
                    <IconButton onClick={handleCloseTerminateDialog} size="small">
                        <CloseIcon size={20} />
                    </IconButton>
                </DialogTitleStyled>

                <DialogContent sx={{ pt: 3 }}>
                    <Alert severity="warning" sx={{ mb: 3 }}>
                        This action will terminate the lease and mark the unit as vacant. This cannot be undone.
                    </Alert>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Reason for Termination"
                                value={terminateForm.terminationReason}
                                onChange={(e) => setTerminateForm({ ...terminateForm, terminationReason: e.target.value })}
                                placeholder="e.g., End of contract, Eviction, Tenant request"
                                multiline
                                rows={2}
                                required
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Vacate Date"
                                type="date"
                                value={terminateForm.vacateDate}
                                onChange={(e) => setTerminateForm({ ...terminateForm, vacateDate: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                                required
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <MuiSwitch
                                        checked={terminateForm.refundDeposit}
                                        onChange={(e) => setTerminateForm({ ...terminateForm, refundDeposit: e.target.checked })}
                                    />
                                }
                                label="Process Deposit Refund"
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', ml: 4 }}>
                                Outstanding balance will be deducted from deposit before refund
                            </Typography>
                        </Grid>

                        {leaseDetails && terminateForm.refundDeposit && (
                            <Grid item xs={12}>
                                <Alert severity="info" icon={<Info size={20} />}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                        Refund Calculation:
                                    </Typography>
                                    <Box sx={{ fontSize: '0.875rem' }}>
                                        <div>Deposit Held: KES {parseFloat(leaseDetails.deposit_held || 0).toLocaleString()}</div>
                                        <div>Outstanding Balance: KES {((leaseDetails.total_arrears || 0) + (leaseDetails.total_pending_bills || 0)).toLocaleString()}</div>
                                        <Divider sx={{ my: 0.5 }} />
                                        <div style={{ fontWeight: 600 }}>
                                            Refund Amount: KES {Math.max(0, parseFloat(leaseDetails.deposit_held || 0) - ((leaseDetails.total_arrears || 0) + (leaseDetails.total_pending_bills || 0))).toLocaleString()}
                                        </div>
                                    </Box>
                                </Alert>
                            </Grid>
                        )}

                        {leaseDetails && leaseDetails.wallet_balance !== undefined && leaseDetails.wallet_balance !== 0 && (
                            <Grid item xs={12}>
                                {leaseDetails.status === "PAID" ? (
                                    <Alert severity="success" icon={<CheckCircle size={20} />}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                            Tenant Overpayment (Refund Due)
                                        </Typography>
                                        <Typography variant="body2">
                                            Wallet Balance: <strong>KES {parseFloat(leaseDetails.wallet_balance || 0).toLocaleString()}</strong>
                                        </Typography>
                                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                            The tenant has overpaid. This amount is due as a refund upon lease termination.
                                        </Typography>
                                    </Alert>
                                ) : (
                                    <Alert severity="warning" icon={<AlertCircle size={20} />}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                            Tenant Outstanding Balance
                                        </Typography>
                                        <Typography variant="body2">
                                            Amount Owing: <strong>KES {parseFloat(leaseDetails.wallet_balance || 0).toLocaleString()}</strong>
                                        </Typography>
                                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                            The tenant owes this amount. Consider collecting it before terminating the lease.
                                        </Typography>
                                    </Alert>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e0e0e0' }}>
                    <Button onClick={handleCloseTerminateDialog} disabled={terminateLoading}>
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={terminateLoading}
                        variant="contained"
                        color="error"
                        onClick={handleTerminateLease}
                    >
                        Terminate Lease
                    </LoadingButton>
                </DialogActions>
            </StyledTerminateDialog>


            {notices.length === 0 ? (
                <div className="user">
                    <div
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            flexDirection: matches ? "column" : "row",
                            justifyContent: "space-between",
                            gap: "20px", // Adds spacing between elements
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: "40vh",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "20px", // Adds padding for better spacing
                                backgroundColor: "#FAFAFA", // Light background for contrast
                                borderRadius: "10px", // Soft rounded corners
                                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
                            }}
                        >
                            {notices.length === 0 ? (
                                <div style={{textAlign: "center", padding: "20px"}}>
                                    <p style={{
                                        marginBottom: "15px",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        color: "#333"
                                    }}>
                                        No vacating notices found.
                                    </p>
                                    <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
                                       {/* <Button
                                            variant="outlined"
                                            sx={{
                                                textTransform: "none",
                                                backgroundColor: "#FBF4F0",
                                                padding: "8px 20px",
                                                borderRadius: "8px",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                    backgroundColor: "#F2E6E0",
                                                },
                                            }}
                                            onClick={() => setForceVacatingModal(true)}
                                        >
                                            Add New Notice
                                        </Button>*/}
                                        <Tooltip title={!isLeaseActive ? "Lease is already terminated" : ""}>
                                            <span>
                                                <TerminateButton
                                                    variant="contained"
                                                    startIcon={<LogOut size={18} />}
                                                    onClick={handleOpenTerminateDialog}
                                                    disabled={!isLeaseActive}
                                                >
                                                    Terminate Lease
                                                </TerminateButton>
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div style={{marginBottom: "15px", display: "flex", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap"}}>
                                       {/* <Button
                                            variant="outlined"
                                            sx={{
                                                textTransform: "none",
                                                backgroundColor: "#FBF4F0",
                                                padding: "8px 20px",
                                                borderRadius: "8px",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                    backgroundColor: "#F2E6E0",
                                                },
                                            }}
                                            onClick={() => setForceVacatingModal(true)}
                                        >
                                            Add New Notice
                                        </Button>*/}
                                        <Tooltip title={!isLeaseActive ? "Lease is already terminated" : ""}>
                                            <span>
                                                <TerminateButton
                                                    variant="contained"
                                                    startIcon={<LogOut size={18} />}
                                                    onClick={handleOpenTerminateDialog}
                                                    disabled={!isLeaseActive}
                                                >
                                                    Terminate Lease
                                                </TerminateButton>
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <StyledDataGrid
                                        rows={notices}
                                        columns={noticeColumns}
                                        disableSelectionOnClick
                                        pageSize={10}
                                        rowsPerPageOptions={[10]}
                                        autoHeight
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div style={{marginBottom: "15px", display: "flex", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap"}}>
                        {/*<Button
                            variant="outlined"
                            sx={{
                                textTransform: "none",
                                backgroundColor: "#FBF4F0",
                                padding: "8px 20px",
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: "500",
                                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                    backgroundColor: "#F2E6E0",
                                },
                            }}
                            onClick={() => setForceVacatingModal(true)}
                        >
                            Add New Notice
                        </Button>*/}
                        <Tooltip title={!isLeaseActive ? "Lease is already terminated" : ""}>
                            <span>
                                <TerminateButton
                                    variant="contained"
                                    startIcon={<LogOut size={18} />}
                                    onClick={handleOpenTerminateDialog}
                                    disabled={!isLeaseActive}
                                >
                                    Terminate Lease
                                </TerminateButton>
                            </span>
                        </Tooltip>
                    </div>
                    <StyledDataGrid
                        rows={notices}
                        columns={noticeColumns}
                        disableSelectionOnClick
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        autoHeight
                    />
                </>
            )}

        </div>
    )
}